import React, {Suspense} from "react";
import {BrowserRouter, Navigate, Route} from "react-router-dom";
import {Routes} from "react-router";
import LoadingPage from "./components/LoadingPage";

// convert to lazy import
// import PdfWizHome from "./components/pdf_wiz/PdfWizHome";
// import PdfWizBase from "./components/pdf_wiz/PdfWizBase";
// import PdfWizMerge from "./components/pdf_wiz/PdfWizMerge";
// import PdfWizSplit from "./components/pdf_wiz/PdfWizSplit";
import Countdown from "./components/countdown/Countdown";

const Home = React.lazy(() => import("./components/home/Home"));
const PageNotFound = React.lazy(() => import("./components/PageNotFound"));

const App = () => {
    return (
        <BrowserRouter>
            <Suspense fallback={<LoadingPage/>}>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/home" element={<Navigate to='/'/>}/>
                    <Route path="/loading" element={<LoadingPage/>}/>
                    <Route path="/countdown" element={<Countdown/>}/>
                    <Route path="*" element={<PageNotFound/>}/>
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
};

export default App;
